import defaultClient from '@src/api/clients/default';

const BASE = 'dashboard/zip-recommendations';

export function fetchZipRecommendations(params = {}) {
  return defaultClient.request({
    url: `${BASE}/`,
    method: 'GET',
    options: { params },
  });
}

export function fetchZipRecommendationsSummary(params = {}) {
  return defaultClient.request({
    url: `${BASE}/summary/`,
    method: 'GET',
    options: { params },
  });
}

export function generateZipRecommendations(clientId, { endDate = null, runAsync = true } = {}) {
  const payload = { client_id: clientId, async: runAsync };
  if (endDate) payload.end_date = endDate;
  return defaultClient.request({
    url: `${BASE}/generate/`,
    method: 'POST',
    payload,
  });
}

export function approveZipRecommendation(id, { apply = false } = {}) {
  return defaultClient.request({
    url: `${BASE}/${id}/approve/`,
    method: 'POST',
    payload: apply ? { apply: true } : {},
  });
}

export function rejectZipRecommendation(id, reason = '') {
  return defaultClient.request({
    url: `${BASE}/${id}/reject/`,
    method: 'POST',
    payload: { reason },
  });
}

export function applyZipRecommendation(id) {
  return defaultClient.request({
    url: `${BASE}/${id}/apply/`,
    method: 'POST',
    payload: {},
  });
}

export function revertZipRecommendation(id, reason = '') {
  return defaultClient.request({
    url: `${BASE}/${id}/revert/`,
    method: 'POST',
    payload: { reason },
  });
}

export function bulkApproveZipRecommendations({ ids, apply = false }) {
  return defaultClient.request({
    url: `${BASE}/bulk-approve/`,
    method: 'POST',
    payload: { ids, apply },
  });
}

export function bulkRejectZipRecommendations({ ids, reason = '' }) {
  return defaultClient.request({
    url: `${BASE}/bulk-reject/`,
    method: 'POST',
    payload: { ids, reason },
  });
}

export function bulkApplyZipRecommendations({ ids }) {
  return defaultClient.request({
    url: `${BASE}/bulk-apply/`,
    method: 'POST',
    payload: { ids },
  });
}
